// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/login`,
      verify: `${ROOTS.AUTH}/verify`,
      register: `${ROOTS.AUTH}/register`,
      forgotPassword: `${ROOTS.AUTH}/forgot-password`,
      resetPassword: `${ROOTS.AUTH}/reset-password`,
      mfaVerification: `${ROOTS.AUTH}/mfa-verification`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    one: `${ROOTS.DASHBOARD}/main`,
    two: `${ROOTS.DASHBOARD}/two`,
    three: `${ROOTS.DASHBOARD}/three`,
    productivity: `${ROOTS.DASHBOARD}/productivity`,
    adjustment: `${ROOTS.DASHBOARD}/adjustment`,
    ar: `${ROOTS.DASHBOARD}/ar`,
    denial: `${ROOTS.DASHBOARD}/denial`,
    action: `${ROOTS.DASHBOARD}/action`,
    pro: `${ROOTS.DASHBOARD}/pro`,
    admin: {
      root: `${ROOTS.DASHBOARD}/admin`,
      five: `${ROOTS.DASHBOARD}/admin/five`,
      six: `${ROOTS.DASHBOARD}/admin/six`,
      Logs: `${ROOTS.DASHBOARD}/admin/logs`,
      tenants: `${ROOTS.DASHBOARD}/admin/tenants`,
      articles: `${ROOTS.DASHBOARD}/admin/articles`
    },
  },
};


